// Module
var code = "<correct-mark params=\"status: status\"></correct-mark>\n";
// Exports
module.exports = code;